// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PeriodDateSelector_root__Z5t3T {
  display: inline-flex;
  align-items: stretch;
  height: 36px;
  flex-shrink: 0;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #e2e5e8);
  border-radius: 8px;
  overflow: hidden;
}

.PeriodDateSelector_dropdown__cz2ep {
  display: flex;
  align-items: stretch;
  height: 100%;
}

.PeriodDateSelector_divider__UIJDn {
  width: 1px;
  align-self: stretch;
  background: var(--m-border, #e2e5e8);
}

.PeriodDateSelector_arrowBtn__OPtt6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--m-text-muted, #6a768b);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s, color 0.12s;
}
.PeriodDateSelector_arrowBtn__OPtt6:hover:not(:disabled) {
  background: var(--m-dropdown-hover, #f6f7fb);
  color: var(--m-text, #162949);
}
.PeriodDateSelector_arrowBtn__OPtt6:disabled {
  opacity: 0.28;
  cursor: not-allowed;
}

.PeriodDateSelector_trigger__yzKeJ {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 168px;
  height: 100%;
  padding: 0 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background 0.12s;
}
.PeriodDateSelector_trigger__yzKeJ:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.PeriodDateSelector_triggerIcon__de7Vl,
.PeriodDateSelector_triggerCaret__OjGlc {
  flex-shrink: 0;
  color: var(--m-text-muted, #6a768b);
}

.PeriodDateSelector_triggerLabel__5MhmX {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #162949);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.PeriodDateSelector_dayOnly__huBxm .PeriodDateSelector_trigger__yzKeJ {
  width: 108px;
  justify-content: center;
}

.PeriodDateSelector_dayOnly__huBxm .PeriodDateSelector_triggerLabel__5MhmX {
  text-align: center;
}

.PeriodDateSelector_popoverShell__wsrt5 .dropdown__content-inner {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
}
.PeriodDateSelector_popoverShell__wsrt5 .dropdown__items-container {
  overflow: visible;
  max-height: none !important;
}
.PeriodDateSelector_popoverShell__wsrt5 .dropdown-item {
  padding: 0;
  width: 100%;
}
.PeriodDateSelector_popoverShell__wsrt5 .dropdown-item:hover::before, .PeriodDateSelector_popoverShell__wsrt5 .dropdown-item.PeriodDateSelector_active__DY15y::before {
  display: none;
}
.PeriodDateSelector_popoverShell__wsrt5 .dropdown-item:hover {
  background: transparent;
}

.PeriodDateSelector_panel__OFa0N {
  width: 240px;
  padding: 10px 8px 8px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 10px;
  box-shadow: var(--m-dropdown-shadow, 0 8px 24px rgba(0, 0, 0, 0.12));
}

.PeriodDateSelector_heading__ioHTc {
  margin: 0 8px 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--m-text-muted, #6a768b);
}

.PeriodDateSelector_presetList__wsLUR {
  list-style: none;
  margin: 0;
  padding: 0;
}

.PeriodDateSelector_presetItem__Jtt4F {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;
}
.PeriodDateSelector_presetItem__Jtt4F:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.PeriodDateSelector_presetItemActive__MQBPD {
  background: var(--m-background-subtle-primary, #f0f9ff);
  font-weight: 600;
}

.PeriodDateSelector_check__jPZw\\+ {
  flex-shrink: 0;
  color: var(--m-primary, #00b4f3);
}

.PeriodDateSelector_rule__\\+jI6o {
  height: 1px;
  margin: 6px 4px;
  background: var(--m-border, #e2e5e8);
}

.PeriodDateSelector_customFields__xtddJ {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 6px 4px;
}

.PeriodDateSelector_field__tU-7M {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-muted, #6a768b);
}
.PeriodDateSelector_field__tU-7M input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 500;
}
.PeriodDateSelector_field__tU-7M input:focus {
  outline: none;
  border-color: var(--m-primary, #00b4f3);
}

.PeriodDateSelector_applyBtn__vEFMx {
  padding: 7px 10px;
  border: none;
  border-radius: 6px;
  background: var(--m-primary, #00b4f3);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.PeriodDateSelector_applyBtn__vEFMx:hover:not(:disabled) {
  opacity: 0.92;
}
.PeriodDateSelector_applyBtn__vEFMx:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.PeriodDateSelector_summary__tlctB {
  margin: 6px 10px 2px;
  font-size: 12px;
  font-weight: 500;
  color: var(--m-text-muted, #6a768b);
}

.PeriodDateSelector_todayBtn__WP9dA {
  display: block;
  width: calc(100% - 8px);
  margin: 4px 4px 2px;
  padding: 7px 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--m-primary, #00b4f3);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
}
.PeriodDateSelector_todayBtn__WP9dA:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

@media (max-width: 768px) {
  .PeriodDateSelector_root__Z5t3T {
    width: 100%;
  }
  .PeriodDateSelector_trigger__yzKeJ {
    flex: 1 1;
    width: auto;
  }
  .PeriodDateSelector_panel__OFa0N {
    width: min(240px, 100vw - 24px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/PeriodDateSelector/PeriodDateSelector.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;EACA,mBAAA;EACA,oCAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,mCAAA;EACA,eAAA;EACA,cAAA;EACA,yCAAA;AACF;AACE;EACE,4CAAA;EACA,6BAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AADF;AAGE;EACE,4CAAA;AADJ;;AAKA;;EAEE,cAAA;EACA,mCAAA;AAFF;;AAKA;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,YAAA;EACA,uBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAME;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AAHJ;AAME;EACE,iBAAA;EACA,2BAAA;AAJJ;AAOE;EACE,UAAA;EACA,WAAA;AALJ;AAOI;EAEE,aAAA;AANN;AASI;EACE,uBAAA;AAPN;;AAYA;EACE,YAAA;EACA,qBAAA;EACA,gDAAA;EACA,0CAAA;EACA,mBAAA;EACA,oEAAA;AATF;;AAYA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;AATF;;AAYA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AATF;AAWE;EACE,4CAAA;AATJ;;AAaA;EACE,uDAAA;EACA,gBAAA;AAVF;;AAaA;EACE,cAAA;EACA,gCAAA;AAVF;;AAaA;EACE,WAAA;EACA,eAAA;EACA,oCAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAVF;AAYE;EACE,WAAA;EACA,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAVJ;AAYI;EACE,aAAA;EACA,uCAAA;AAVN;;AAeA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAZF;AAcE;EACE,aAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;AAbJ;;AAiBA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAdF;;AAiBA;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAdF;AAgBE;EACE,4CAAA;AAdJ;;AAkBA;EACE;IACE,WAAA;EAfF;EAkBA;IACE,SAAA;IACA,WAAA;EAhBF;EAmBA;IACE,+BAAA;EAjBF;AACF","sourcesContent":[".root {\n  display: inline-flex;\n  align-items: stretch;\n  height: 36px;\n  flex-shrink: 0;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #e2e5e8);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.dropdown {\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n}\n\n.divider {\n  width: 1px;\n  align-self: stretch;\n  background: var(--m-border, #e2e5e8);\n}\n\n.arrowBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--m-text-muted, #6a768b);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.12s, color 0.12s;\n\n  &:hover:not(:disabled) {\n    background: var(--m-dropdown-hover, #f6f7fb);\n    color: var(--m-text, #162949);\n  }\n\n  &:disabled {\n    opacity: 0.28;\n    cursor: not-allowed;\n  }\n}\n\n.trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 168px;\n  height: 100%;\n  padding: 0 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.triggerIcon,\n.triggerCaret {\n  flex-shrink: 0;\n  color: var(--m-text-muted, #6a768b);\n}\n\n.triggerLabel {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n}\n\n.dayOnly .trigger {\n  width: 108px;\n  justify-content: center;\n}\n\n.dayOnly .triggerLabel {\n  text-align: center;\n}\n\n.popoverShell {\n  :global(.dropdown__content-inner) {\n    padding: 0;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n\n  :global(.dropdown__items-container) {\n    overflow: visible;\n    max-height: none !important;\n  }\n\n  :global(.dropdown-item) {\n    padding: 0;\n    width: 100%;\n\n    &:hover::before,\n    &.active::before {\n      display: none;\n    }\n\n    &:hover {\n      background: transparent;\n    }\n  }\n}\n\n.panel {\n  width: 240px;\n  padding: 10px 8px 8px;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 10px;\n  box-shadow: var(--m-dropdown-shadow, 0 8px 24px rgba(0, 0, 0, 0.12));\n}\n\n.heading {\n  margin: 0 8px 6px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--m-text-muted, #6a768b);\n}\n\n.presetList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.presetItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.presetItemActive {\n  background: var(--m-background-subtle-primary, #f0f9ff);\n  font-weight: 600;\n}\n\n.check {\n  flex-shrink: 0;\n  color: var(--m-primary, #00b4f3);\n}\n\n.rule {\n  height: 1px;\n  margin: 6px 4px;\n  background: var(--m-border, #e2e5e8);\n}\n\n.customFields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 6px 4px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--m-text-muted, #6a768b);\n\n  input {\n    width: 100%;\n    padding: 6px 8px;\n    border: 1px solid var(--m-border, #d0d5dd);\n    border-radius: 6px;\n    background: var(--m-card-background-color, #fff);\n    color: var(--m-text, #162949);\n    font-size: 13px;\n    font-weight: 500;\n\n    &:focus {\n      outline: none;\n      border-color: var(--m-primary, #00b4f3);\n    }\n  }\n}\n\n.applyBtn {\n  padding: 7px 10px;\n  border: none;\n  border-radius: 6px;\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    opacity: 0.92;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.summary {\n  margin: 6px 10px 2px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--m-text-muted, #6a768b);\n}\n\n.todayBtn {\n  display: block;\n  width: calc(100% - 8px);\n  margin: 4px 4px 2px;\n  padding: 7px 10px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--m-primary, #00b4f3);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    width: 100%;\n  }\n\n  .trigger {\n    flex: 1;\n    width: auto;\n  }\n\n  .panel {\n    width: min(240px, calc(100vw - 24px));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PeriodDateSelector_root__Z5t3T`,
	"dropdown": `PeriodDateSelector_dropdown__cz2ep`,
	"divider": `PeriodDateSelector_divider__UIJDn`,
	"arrowBtn": `PeriodDateSelector_arrowBtn__OPtt6`,
	"trigger": `PeriodDateSelector_trigger__yzKeJ`,
	"triggerIcon": `PeriodDateSelector_triggerIcon__de7Vl`,
	"triggerCaret": `PeriodDateSelector_triggerCaret__OjGlc`,
	"triggerLabel": `PeriodDateSelector_triggerLabel__5MhmX`,
	"dayOnly": `PeriodDateSelector_dayOnly__huBxm`,
	"popoverShell": `PeriodDateSelector_popoverShell__wsrt5`,
	"active": `PeriodDateSelector_active__DY15y`,
	"panel": `PeriodDateSelector_panel__OFa0N`,
	"heading": `PeriodDateSelector_heading__ioHTc`,
	"presetList": `PeriodDateSelector_presetList__wsLUR`,
	"presetItem": `PeriodDateSelector_presetItem__Jtt4F`,
	"presetItemActive": `PeriodDateSelector_presetItemActive__MQBPD`,
	"check": `PeriodDateSelector_check__jPZw+`,
	"rule": `PeriodDateSelector_rule__+jI6o`,
	"customFields": `PeriodDateSelector_customFields__xtddJ`,
	"field": `PeriodDateSelector_field__tU-7M`,
	"applyBtn": `PeriodDateSelector_applyBtn__vEFMx`,
	"summary": `PeriodDateSelector_summary__tlctB`,
	"todayBtn": `PeriodDateSelector_todayBtn__WP9dA`
};
export default ___CSS_LOADER_EXPORT___;
